import { Phonebook } from "./components/Phonebook/Phonebook.jsx";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Phonebook />
    </div>
  );
}

export default App;
